import { z } from 'zod';
import { ValidationRule } from './common';

export const BaseValidatorSchema = z.object({
  type: z.string(),
  message: z.string().optional(),
  applyWhen: ValidationRule.optional(),
  considerRequired: z.boolean().optional(),
  value: z.any().optional(),
});

export type TBaseValidatorSchema = z.infer<typeof BaseValidatorSchema>;
